import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M9 4l0 16","key":"svg-1"}]]

const IconLayoutSidebar = createReactComponent('outline', 'layout-sidebar', 'LayoutSidebar', __iconNode);

export default IconLayoutSidebar;